var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "location-nav-container",
    style: `width: ${_vm.footerWidth}`
  }, [_c('div', {
    staticClass: "location-nav-wrapper"
  }, [_c('portal', {
    attrs: {
      "to": "body"
    }
  }, [_vm.notificationsModal ? _c('Notifications', {
    staticClass: "notifications-modal",
    attrs: {
      "notifications": _vm.alarms,
      "settings-link": _vm.alarmNotificationsLink
    },
    model: {
      value: _vm.notificationsModal,
      callback: function ($$v) {
        _vm.notificationsModal = $$v;
      },
      expression: "notificationsModal"
    }
  }) : _vm._e()], 1), _vm.locationId ? _c('LocationFloatingBarOptions', {
    attrs: {
      "notification-count": _vm.notificationCount
    },
    on: {
      "open-notifications-modal": _vm.openNotificationsModal
    }
  }) : _vm._e(), _vm.locationGroupId && !_vm.locationId ? _c('GroupFloatingBarOptions', {
    attrs: {
      "notification-count": _vm.notificationCount
    },
    on: {
      "open-notifications-modal": _vm.openNotificationsModal
    }
  }) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }